import { todayKey, weekIndex } from "./streak";

// Consecutive weeks (ending this or last week) where lesson steps >= weekly goal.
export const goalStreakWeeks = (stepLog = {}, goal) => {
  if (!goal) return 0;
  const perWeek = {};
  Object.entries(stepLog).forEach(([k, v]) => {
    if (k.length === 10) perWeek[weekIndex(k)] = (perWeek[weekIndex(k)] || 0) + (Number(v) || 0);
  });
  let w = weekIndex(todayKey());
  if ((perWeek[w] || 0) < goal) w -= 1; // current week still in progress
  let weeks = 0;
  while ((perWeek[w] || 0) >= goal) { weeks += 1; w -= 1; }
  return weeks;
};

export const GOAL_TIERS = [
  { tier: "gold", label: "Gold", minWeeks: 12, color: "#c9a227", bg: "#fff8e1" },
  { tier: "silver", label: "Silver", minWeeks: 8, color: "#6b7280", bg: "#f3f4f6" },
  { tier: "bronze", label: "Bronze", minWeeks: 4, color: "#b06a2c", bg: "#fdf0e6" },
];

export const goalBadge = (weeks) => GOAL_TIERS.find((t) => weeks >= t.minWeeks) || null;
export const nextGoalTier = (weeks) => [...GOAL_TIERS].reverse().find((t) => weeks < t.minWeeks) || null;
